import { STATUS_BADGES } from './constants';

export function initials(name) {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
}

// Date-only payloads shift a day in a negative-offset timezone, so parts are read off the string.
export function formatDay(value) {
  if (!value) return null;
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-US', {
    month: 'short', day: '2-digit', timeZone: 'UTC',
  });
}

export function humanize(value) {
  if (!value) return null;
  const words = String(value).replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function joinParts(parts) {
  return parts.filter(Boolean).join(' · ');
}

// Turbo persists this dialog across navigation, so a plain click must close it explicitly.
export function closeOnPlainClick(event, onNavigate) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  onNavigate();
}

export function statusBadgeFor(type, value, label) {
  const badge = STATUS_BADGES[type]?.[value];
  return badge ? { ...badge, label: label || badge.label } : null;
}

export function buildRow(type, row) {
  switch (type) {
    case 'learners':
      return {
        url: row.url,
        avatarInitial: initials(row.fullName),
        title: row.fullName,
        subtitle: joinParts([row.email, row.regionName, humanize(row.role)]),
        statusBadge: statusBadgeFor('learners', row.complianceStatusVariant, row.complianceStatusLabel),
        meta: row.dueAt ? `Due ${formatDay(row.dueAt)}` : null,
      };
    case 'trainings':
      return {
        url: row.url,
        title: row.title,
        subtitle: joinParts([
          row.duration ? `${row.duration} min` : null,
          row.chaptersCount ? `${row.chaptersCount} lessons` : null,
          row.categoryName,
        ]),
        tagBadge: row.llamaBite ? { label: 'Llama bite' } : null,
        statusBadge: statusBadgeFor('trainings', row.status),
        meta: row.assignedCount ? `${row.assignedCount} assigned` : 'Not assigned',
      };
    case 'classrooms':
      return {
        url: row.url,
        title: row.name,
        statusBadge: statusBadgeFor('classrooms', row.status),
      };
    case 'journeys':
      return {
        url: row.url,
        title: row.title,
        meta: row.learnersCount != null ? `${row.learnersCount} learners` : null,
      };
    case 'locations':
    case 'groups':
      return {
        url: row.url,
        title: row.name,
        meta: row.learnersCount != null ? `${row.learnersCount} learners` : null,
      };
    case 'documents':
      return {
        url: row.url,
        title: row.name,
        subtitle: row.updatedAt ? `Updated ${formatDay(row.updatedAt)}` : null,
        meta: row.fileType,
      };
    case 'kiosk':
    default:
      return { url: row.url, title: row.name };
  }
}
